var React = require('react');

function Megaphone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z","key":0}),React.createElement("path",{"d":"M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14","key":1}),React.createElement("path",{"d":"M8 6v8","key":2})]);
}

Megaphone.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-megaphone-icon lucide-megaphone"};

module.exports = Megaphone;

Megaphone.default = Megaphone;
